import { createSlice } from "@reduxjs/toolkit";
import editHospitalCaseCredit from "@custom/rtk-apis/Setting/creditForCaseToCase/updateHospitalCaseCredit";

const initialState = {
    status: "",
    result: {},
    msg: "",
    loading: false,
    error: ""
};

const editHospitalCaseCreditSlice = createSlice({
    name: "editHospitalCaseCreditSlice",
    initialState,
    reducers: {
        clearEditHospitalCaseCreditState: (state: any) => {
            state.status = '';
            state.result = {};
            state.msg = '';
            state.loading = false;
            state.error = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(editHospitalCaseCredit.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(editHospitalCaseCredit.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.status = payload.status;
                state.result = payload.data;
                state.msg = payload.msg;
            })
            .addCase(editHospitalCaseCredit.rejected, (state, { payload }) => {
                state.result = payload;
                state.loading = false;
                state.status = 'ERROR'
            });
    },
});

export default editHospitalCaseCreditSlice.reducer;
export const { clearEditHospitalCaseCreditState } = editHospitalCaseCreditSlice.actions;
